<template lang="pug">
  div(:class="[statusClass, iconClass]")
    span.map-icon__point
    div.progress-bar
      div.progress-bar__loaded

</template>

<script>
import baseMapIconMixin from './base-map-icon-mixin'

const msnColors = {
  '#008000': 'green',
  '#9ACD32': 'turquoise',
  '#FFFF00': 'yellow',
}

export default {
  name: 'map-icon-object',
  mixins: [baseMapIconMixin],
  props: {
    iconType: {
      type: String,
      default: 'garbage',
    },
    iconSubType: {
      type: String,
      default: 'garbage',
    },
    progress: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      fields: {},
    }
  },
  computed: {
    iconClass() {
      let iC = 'map-icon map-icon_' + this.iconType
      iC += ' map-icon_' + this.iconSubType

      return iC
    },
  },
  methods: {
    injectConf(options = {}) {
      let { iconType, iconSubType, model = {} } = options
      this.fields = Object.assign({}, model)
      const msnColor = this.fields.arrangement_color
        ? msnColors[this.fields.arrangement_color]
        : 'bluegreen'
      iconType += ' map-icon-' + msnColor
      this.iconType = iconType
      this.iconSubType = iconSubType
      this.registerVueInMap()
    },
  },
}
</script>
